import get from 'lodash/get';
import { caseLogicMsg } from '~lib/common/validators/validationMessages';

export function validateRequiredFields(requiredFields, node, nodeType, controlTypes = [], checkKey = null) {
  const errors = [];
  
  if (!requiredFields || requiredFields.length < 1) return errors;
  
  const nodeOfTypeKey = checkKey || nodeType;
  const nodeOfType = get(node, 'data.' + nodeOfTypeKey);
  if (!nodeOfType) return;
  if (!controlTypes.includes(nodeOfType.type)) return;

  requiredFields.forEach(field => {
    const { key, label, errorId, article = 'a' } = field || {};
    if (!nodeOfType[key]) {
      errors.push(caseLogicMsg('You need to select ' + article + ' ' + label, node.id, { errorId }));
      return;
    }
  });
  
  return errors;
}